// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b4fab4c4] .el-tag--dark.el-tag--warning {\n  background-color: #e6a23c !important;\n}\n", ""]);
// Exports
module.exports = exports;
